export const funnelRoute = {
    path: "/funnel",
    name: "埋点分析",
    meta: { title: "埋点分析", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "behavior_convert",
            name: "转化分析",
            component: resolve =>
                require(["@/components/funnel/Convert"], resolve),
            meta: { title: "用户行为转化分析" }
        },
        {
            path: "event_tracking",
            name: "埋点分析",
            component: resolve =>
                require(["@/components/funnel/EventTracking"], resolve),
            meta: { title: "埋点数据转化分析" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/funnel.js